import React from "react";
import styles from "./Info.module.css";
// import man from "../../../../assets/man1.png";
import man from '../../../../assets/dummy.png';

import { ImClock2 } from "react-icons/im";
import { FaCalendarAlt } from "react-icons/fa";
// import { IMG_URL } from "../../store/Apis";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { IMG_URL } from "../../../../store/Apis";
import { useLocation } from "react-router-dom";
import { roles } from "../../../../config/roles";

const Info = (data) => {
  const role = localStorage.getItem('role');
  console.log('data', data)

  const Data = data?.data?.state

  const location = useLocation();

  const { t } = useTranslation();


  const phoneFormat = (text) => {

    var cleaned = ("" + text).replace(/\D/g, "");
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      var intlCode = match[1] ? "+1 " : "",
        number = [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join(
          ""
        );
      return number;
    }
    return text;
  }

  return (
    <div className={styles.mainContainer}>
      <div className={styles.box_one}>
        <div className={styles.box_sub_view}>
          <img src={Data?.customer_image
            ? IMG_URL + Data?.customer_image : man} className={styles.profile_image} />
          <div className={styles.box_heading_view}>
            <h1 className={styles.box_sub_heading}>{Data?.customer_name}</h1>
            {role == roles?.cleaner ? null :
              <text className={styles.span}>{t(Data?.service_type)}</text>
            }
          </div>
        </div>
        <h1 className={styles.box_heading}>{t("Basic Information")}</h1>
        <div className={styles.flex}>
          <div>
            <h1 className={styles.span}>{t("Email")}</h1>
            <text className={styles.text}>{Data?.customer_email}</text>
          </div>

          <div className={styles.location}>
            <h1 className={styles.span}>{t("Location")}</h1>
            <text className={styles.text}>{Data?.location?.address}</text>
          </div>
        </div>

        <div className={styles.contact_view}>
          <h1 className={styles.span}>{t("Contact Number")}</h1>
          <text className={styles.text}>{phoneFormat(Data?.customer_contact)}</text>
        </div>
      </div>

      <div className={styles.second_portion}>
        <div className={styles.box_two}>
          <div className={styles.box_two_text_view}>
            <h1 className={styles.box_sub_headingx}>{t("Service Name")}</h1>
            <h5 className={styles.span}>{t(Data?.service_name)}</h5>
          </div>

          <div className={styles.task_view}>
            <h5 className={styles.span}>{t("Task Details")}</h5>
            <div className={styles.task_list_view}>
              <h5 className={styles.span}>{Data?.details}</h5>
              {/* {tasks.map((item, index) => {
                return <text className={styles.task_text}>House Cleaning</text>;
              })} */}
            </div>
          </div>
        </div>

        <div className={styles.box_three}>
          <h1 className={styles.box_sub_headingx}>{location?.state.screen == 'pastjobs' ? t("Task Completion Time") : t("Date and Time")}</h1>
          <div className={styles.flexC}>
            <ImClock2 className={styles.icon} color={"#f6921e"} />
            <h5 className={styles.box_three_span}>{Data?.start_time
              ? moment('01 jan 1947 ' + Data?.start_time).format('hh:mm A') + ' TO ' + moment('01 jan 1947 ' + Data?.end_time).format('hh:mm A')
              : ''}</h5>
          </div>

          <div className={styles.flexC}>
            <FaCalendarAlt className={styles.icon} color={"#f6921e"} />
            <h5 className={styles.box_three_span}>{Data?.date
              ? moment(Data?.date).format('MM-DD-YYYY')
              : ''}</h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Info;
